const common = {
    no_data: 'ไม่มีข้อมูล',
    header: {
        business_name: 'ธุรกิจของคุณ'
    },
    download_app: {
        text: 'หากต้องการใช้ Simply เวอร์ชันเว็บ กรุณาใช้แล็ปท็อปหรือพีซี',
        button: 'ดาวน์โหลดเวอร์ชันมือถือ'
    },
    unknown: 'ไม่ทราบ',
    request_error: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง! หรือ ติดต่อฝ่ายบริการลูกค้าเพื่อรายงานปัญหาของคุณ',
    home: 'หน้าแรก',
    dashboard: 'แดชบอร์ด',
    product: 'สินค้า',
    add_product: 'เพิ่มสินค้า',
    edit_product: 'แก้ไขสินค้า',
    stock_in: 'นำสินค้าเข้า',
    Sales_Turnover: 'ยอดขาย',
    profit: 'กำไร',
    stock_out: 'นำสินค้าออก',
    staff: 'พนักงาน',
    stock_audit: 'ตรวจสอบสต็อก',
    button: {
        save: 'บันทึก',
        save_and_add_more: 'บันทึกและเพิ่มต่อ',
        submit: 'ส่ง',
        done: 'เสร็จสิ้น',
        edit: 'แก้ไข',
        save_edit: 'บันทึกการเปลี่ยนแปลง',
        yes: 'ใช่',
        clear: 'ล้าง',
        delete: 'ลบ',
        cancel: 'ยกเลิก',
        reset: 'รีเซ็ต'
    },
    select_date: 'เลือกวันที่',
    select_action: 'เลือกการดำเนินการ',
    mandatory: ' *(จำเป็น)',
    not_mandatory: '(ไม่จำเป็น)',
    business: 'ธุรกิจ',
    account: 'บัญชี',
    profile: 'โปรไฟล์',
    setting: 'การตั้งค่า',
    whichLanguage: 'ภาษาไทย',
    headerDashboard: 'เป็นสมาชิก VIP',
    contact_us: 'ติดต่อเรา',
    logout: 'ออกจากระบบ',
    category: 'หมวดหมู่',
    add_category: 'เพิ่มหมวดหมู่',
    data: 'ข้อมูล',
    history: 'ประวัติ',
    lowStockAlert: 'แจ้งเตือนสต็อกต่ำ',
    Expenses: 'ค่าใช้จ่าย',
    lowStockAlertButton: 'เพิ่มจำนวนสต็อกความปลอดภัย',
    message: {
        login_success: 'เข้าสู่ระบบสำเร็จ!',
        onboard_success: 'เยี่ยมมาก!! การเดินทางของคุณได้เริ่มต้นแล้ว!',
        successfully_saved: 'บันทึกข้อมูลเรียบร้อยแล้ว',
        successfully_deleted: 'ลบข้อมูลเรียบร้อยแล้ว',
        error_required_field: 'ช่องที่จำเป็นต้องไม่ว่าง',
        no_access: 'ไม่สามารถเข้าถึงได้',
        no_permission: 'คุณไม่มีสิทธิ์',
        error_update_history: 'ไม่สามารถอัปเดตประวัติได้'
    },
    no_permission_dialog: {
        title: 'ไม่มีสิทธิ์',
        description: 'คุณไม่มีสิทธิ์ดูค่าใช้จ่าย กรุณาติดต่อผู้ดูแลระบบของคุณ'
    },
    feedback: 'ให้ข้อเสนอแนะ',
    contact: 'ติดต่อ',
    add: 'เพิ่ม',
    supplier: 'ผู้จำหน่าย',
    customer: 'ลูกค้า',
    random: 'สุ่ม',
    scan: 'สแกน',
    enter: 'เข้าสู่ระบบโดยการสแกนบาร์โค้ด',
    terms: {
        text: 'โดยการดำเนินการต่อ คุณยอมรับ',
        link: 'นโยบายความเป็นส่วนตัว'
    },
    others: 'อื่น ๆ',
    calender: {
        presets: {
            today: 'วันนี้',
            yesterday: 'เมื่อวาน',
            last_7_days: '7 วันที่ผ่านมา',
            last_30_days: '30 วันที่ผ่านมา',
            this_month: 'เดือนนี้',
            last_month: 'เดือนที่แล้ว',
            custom_range: 'ช่วงวันที่กำหนดเอง'
        }
    },
    print_large: 'พิมพ์ขนาดใหญ่ (A4)',
    print_letter: 'พิมพ์ขนาด Letter (US)',
    print_dot_matrix: 'พิมพ์ขนาดใหญ่ (ดอทเมทริกซ์)',
    print_medium: 'พิมพ์ขนาดกลาง (75 มม.)',
    print_small: 'พิมพ์ขนาดเล็ก (48 มม.)',
    format: 'รูปแบบกระดาษ',
    preview: 'ดูตัวอย่าง',
    view_invoice: 'ใบแจ้งหนี้',
    view_chalan: 'ใบส่งของ',
    price: 'ราคา',
    stock: 'สต็อก',
    quantity: 'จำนวน',
    total: 'รวม',
    print_footer_left: 'สร้างโดย',
    print_footer_center: 'พิมพ์เมื่อ',
    print_footer_date: 'เมื่อ',
    print_to: 'ถึง',
    language: 'ภาษาไทย',
    dateStatus: '7 วันที่ผ่านมา',
    placeholder: 'ประเภทธุรกรรม',
    staffHistory: 'เลือกพนักงาน',
    languageTitle: 'ภาษาไทย',
    date: 'วันที่',
    download: 'ดาวน์โหลด',
    download_excel: 'ดาวน์โหลด Excel',
    download_pdf: 'ดาวน์โหลดบาร์โค้ด',
    currentTitle: 'สกุลเงิน',
    Selectperiod: 'เลือกช่วงเวลา',
    TransactionType: 'ประเภทธุรกรรม',
    SelectCustomer: 'เลือกลูกค้า',
    invoice: 'ใบแจ้งหนี้',
    login: {
        google: 'เข้าสู่ระบบด้วย Google',
        apple: 'เข้าสู่ระบบด้วย Apple'
    },
    trusted_by: {
        title: 'ได้รับความไว้วางใจจากธุรกิจกว่า 50,000 แห่ง \n ทั่วประเทศอินโดนีเซีย 🇮🇩'
    },
    privacyPolicyOne: "เมื่อเข้าสู่ระบบ คุณยอมรับ",
    privacyPolicyTwo: 'นโยบายความเป็นส่วนตัว',
    manufacture: 'ผู้ผลิต',
    warehouse: 'คลังสินค้า',
    error: {
        title: 'อ๊ะ! เกิดข้อผิดพลาดบางอย่าง',
        description: 'เกิดข้อผิดพลาดที่ไม่คาดคิด โปรดรีเฟรชหน้า หรือกลับไปที่หน้าหลัก',
        refresh: 'รีเฟรชหน้า',
        go_back: 'กลับไปที่หน้าหลัก',
        not_found: 'ไม่พบหน้า'
    },
    totalPurchasePrice: 'ราคาซื้อรวม',
    pageTotalPurchaseAmount: 'ยอดรวมการสั่งซื้อต่อหน้า',
    approval_status: 'สถานะการอนุมัติ',
    pending: 'รอดำเนินการ',
    approved: 'อนุมัติแล้ว',
    rejected: 'ปฏิเสธ',
    select_fields: 'เลือกฟิลด์',
    syncWithTally: 'ซิงค์กับ Tally',
    importFromTally: 'นำเข้าจาก Tally',
    exportToTally: 'ส่งออกไปยัง Tally',
    All: 'ทั้งหมด',
    Approval: 'การอนุมัติ'
}
export default common